import React, { ReactElement } from 'react'
import ReactPagination from 'react-js-pagination'

interface Props {
  pageRangeDisplayed?: number
  firstPageContent?: ReactElement | string
  lastPageContent?: ReactElement | string
  prevPageContent?: ReactElement | string
  nextPageContent?: ReactElement | string
  onChange: (pageNumber: number) => void
  currentPage: number
  pageSize: number
  totalItems: number
  hideNavigation?: boolean
}

export const Pagination = ({
  pageRangeDisplayed = 5,
  firstPageContent = '«',
  lastPageContent = '»',
  prevPageContent = '<',
  nextPageContent = '>',
  onChange,
  currentPage,
  pageSize,
  totalItems,
  hideNavigation = false
}: Props) => {
  if ((pageSize ?? 0) >= (totalItems ?? 0)) return null
  return (
    <ReactPagination
      hideDisabled
      hideNavigation={hideNavigation}
      firstPageText={firstPageContent}
      lastPageText={lastPageContent}
      prevPageText={prevPageContent}
      nextPageText={nextPageContent}
      activePage={currentPage ?? 0}
      itemsCountPerPage={pageSize}
      totalItemsCount={totalItems ?? 0}
      pageRangeDisplayed={pageRangeDisplayed}
      onChange={onChange}
    />
  )
}
